/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_Howto_2Inputs */

const vi_einvoice_credential_howto_2 = /** @type {(inputs: Einvoice_Credential_Howto_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bước 2: bấm Kiểm tra kết nối. ERP đăng nhập thử vào MISA và tải danh sách mẫu hóa đơn để chắc chắn tài khoản dùng được.`)
};

/**

* @param {Einvoice_Credential_Howto_2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_howto_2 = /** @type {((inputs?: Einvoice_Credential_Howto_2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Howto_2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_howto_2(inputs)
});